// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback } from 'react';

import { ALL_MODULE_ROUTES } from 'app/ModuleRoutes';
import { useGetHasAccess } from 'hooks/user/useHasAccess';

/** Wrapper around useGetHasAccess for use in determining if a user can access a route */
export const useCanAccessRoute = () => {
  const { hasAccess } = useGetHasAccess();

  return useCallback(
    (route: keyof typeof ALL_MODULE_ROUTES) => {
      const { accessArea, accessRequired } = ALL_MODULE_ROUTES[route];
      return hasAccess(accessArea, accessRequired);
    },
    [hasAccess],
  );
};
